import Wrapper from "../../../layout/Wrapper";
import ClameReportComponent from "../../../screens/reports/vehicleReportClaimSummary";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "vehicle Report Claim Summary",
	description: "",
};

export default function ClameReport() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<ClameReportComponent />
		</Wrapper>
	);
}